












import { Component, Vue, Prop } from 'vue-property-decorator';
import CheckboxField from '@/components/CheckboxField.vue';
import { LinkProps } from '@/models/widgets/props/link';
import { CheckboxElement } from '@/models/survey-elements/checkbox-element';
import LinkElement from '@/components/widgets/LinkElement.vue';
import CheckboxLabel from '@/components/CheckboxLabel.vue';
import { EventBus } from '@/event-bus';
import { WIDGET_EVENTS } from '@/const/widget-events';

@Component({
  name: 'checkbox-element-widget',
  components: {
    CheckboxField,
    LinkElement,
    CheckboxLabel,
  },
})
export default class CheckboxElementWidget extends Vue {
  @Prop({ type: Object, required: true }) field!: CheckboxElement;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: Array, required: true }) fillingElements!: {
    key: string;
    element: LinkProps;
  }[];
  @Prop({ type: Boolean }) value!: boolean | null;

  private get localValue(): boolean {
    return this.value || false;
  }

  private get linkAttrs() {
    return this.fillingElements[0];
  }

  private changeHandler(value: string) {
    EventBus.$emit(WIDGET_EVENTS.CHANGE, {
      field: this.field,
      value: value ? value : null,
    });
  }
}
